import React from 'react'
import { Progress, Table, Typography } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { IMovementRS } from '../../../../models/storageModel'
import { groupMovementsByOperator, TGroupedData } from '../../../../utils/reportUtils'
import { TExcelColumn } from '../../../../utils/excelExport'
import { textNumberFormater } from '../../../../utils'

const { Text } = Typography

interface MovementsByOperatorReportProps {
  data: IMovementRS[]
  loading?: boolean
}

export const operatorExcelColumns: TExcelColumn[] = [
  { header: 'Operador / Creador', key: 'label', width: 30 },
  { header: 'Nº Movimientos', key: 'count', width: 16, format: 'number' },
  { header: 'Monto Total', key: 'totalAmount', width: 18, format: 'money' },
  { header: '% Participación', key: 'percentage', width: 16, format: 'percent' }
]

export function getOperatorExcelData(data: IMovementRS[]) {
  return groupMovementsByOperator(data)
}

export const MovementsByOperatorReport: React.FC<MovementsByOperatorReportProps> = ({ data, loading = false }) => {
  const groupedData = groupMovementsByOperator(data)

  const columns: ColumnsType<TGroupedData> = [
    {
      title: '#',
      key: 'index',
      width: 50,
      render: (_, __, index) => index + 1
    },
    {
      title: 'Operador / Creador',
      dataIndex: 'label',
      key: 'label',
      render: (text) => <strong>{text}</strong>
    },
    {
      title: 'Nº Movimientos',
      dataIndex: 'count',
      key: 'count',
      width: 140,
      align: 'right',
      sorter: (a, b) => a.count - b.count,
      render: (count) => textNumberFormater(count)
    },
    {
      title: 'Monto Total',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      width: 180,
      align: 'right',
      sorter: (a, b) => a.totalAmount - b.totalAmount,
      render: (val) => <Text strong style={{ color: '#1890ff' }}>$ {textNumberFormater(val)}</Text>
    },
    {
      title: '% Participación',
      dataIndex: 'percentage',
      key: 'percentage',
      width: 220,
      sorter: (a, b) => a.percentage - b.percentage,
      render: (pct) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Progress percent={pct} size="small" strokeColor="#fa8c16" style={{ flex: 1, margin: 0 }} />
          <span style={{ width: 45, textAlign: 'right', fontSize: '0.85rem' }}>{pct}%</span>
        </div>
      )
    }
  ]

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <Table<TGroupedData>
        columns={columns}
        dataSource={groupedData}
        loading={loading}
        pagination={false}
        size="small"
        bordered
        scroll={{ x: 'max-content' }}
      />
    </div>
  )
}

export default MovementsByOperatorReport
